import { FC } from 'react';
import { Skeleton } from '@mofid-securities/uikit';

export const EfficiencyCompareSkeleton: FC = () => {
  return (
    <>
      <Skeleton height={22} width={140} />
      <div className="my-2 flex justify-center gap-x-3">
        <Skeleton height={18} width={52} />
        <Skeleton height={18} width={52} />
      </div>
      <Skeleton height={250} width="100%" />
      <div className="flex flex-col gap-y-5 pb-6 pt-4">
        <Skeleton height={22} width={200} />
        <Skeleton height={142} width="100%" />
        <Skeleton height={32} width="100%" />
      </div>
    </>
  );
};
